import WhatsApp from './WhatsApp'

export default WhatsApp
// eslint-disable-next-line import/export
export * from './WhatsApp'
